import moment from 'moment';

import { Component, OnInit } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';

import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { FieldTypeSwitchComponent } from '../field-type-switch/field-type-switch.component';
import { FieldTypeTextSimpleComponent } from '../field-type-text/field-type-text-simple/field-type-text-simple.component';
import { FormsModule } from '@angular/forms';
import { FieldTypeRichTextEditableComponent } from "../field-type-rich-text/field-type-rich-text-editable/field-type-rich-text-editable.component";

@Component({
  selector: 'basic-data-modal',
  templateUrl: './basic-data-modal.component.html',
  styleUrls: ['./basic-data-modal.component.scss'],
  standalone: true,
  imports: [FormsModule, FieldTypeTextSimpleComponent, FieldTypeSwitchComponent, AfTranslateDirective, AfTranslatePipe, FieldTypeRichTextEditableComponent]
})
export class BasicDataModalComponent implements OnInit {
  skin: string = this.globalCfg.skin;
  concept:any = this.dialogConfig.data.configuration.concept;
  type:any = this.dialogConfig.data.configuration.type;
  basicDataModal: any = {
    disabledConcept: false,
    sharedPoll: false,
    noEditablePoll: false,
    changedCommunicationChannel: false,
    descriptionField: {
      label: this.translate.instant('common.description'),
      noEditable: this.concept?.poll && this.concept?.disabled
    },
    nameInfo: {
      label: this.translate.instant('common.title'),
      required:  true,
      noEditable: this.concept?.poll && this.concept?.disabled
    },
    conceptData: {
      title: '',
      allowPublicShare: false,
      anonymousAccess: false,
      groupsAsList: true,
      lockedEdit: false,
      stateLockedEdit: false,
      description: '',
      poll: false,
      sequentialView: false,
      communicationChannel: false,
    }
  }

  constructor(private globalCfg: GlobalCfgFactory,
    private translate: AfTranslateFactory,
    private apiService: ApiServiceService,
    private dialogRef: DynamicDialogRef<BasicDataModalComponent>,
    private dialogConfig: DynamicDialogConfig) { }

  ngOnInit(): void {
    if(this.type === 'edit'){
      this.configureModal();
    }
  }

  configureModal(){
    this.basicDataModal.conceptData = {
      title: this.concept.title,
      allowPublicShare: this.concept.allowPublicShare,
      anonymousAccess: this.concept.anonymousAccess,
      groupsAsList: this.concept.groupsAsList,
      lockedEdit: this.concept.lockedEdit,
      stateLockedEdit: this.concept.stateLockedEdit,
      description: this.concept.description,
      poll: this.concept.poll,
      sequentialView: this.concept.sequentialView,
      communicationChannel: this.concept.communicationChannel,
    }
    this.basicDataModal.disabledConcept = (this.concept.conceptId && this.concept.poll);
    this.basicDataModal.sharedPoll = (this.concept.publicShared || this.concept.shared);
    this.basicDataModal.noEditablePoll = (this.concept && this.concept.noEditablePoll);
    this.basicDataModal.disabledPoll = (this.concept.poll && this.concept.disabled);
    this.basicDataModal.disabledAcceptButton = (this.concept.poll && this.concept.disabled);
  }

  itemSelected(e:any, item:string){
    this.basicDataModal.conceptData[item] = e.newValue;
  }

  validateFields(){
    if(this.basicDataModal.conceptData.viewFields){
      this.basicDataModal.conceptData.sequentialView = this.basicDataModal.conceptData.viewFields;
    }

    if(this.basicDataModal.conceptData.title === '' || this.basicDataModal.conceptData.title === undefined){
      this.basicDataModal.nameInfo.error = true;
    }else{
      this.basicDataModal.nameInfo.error = false;
      if (!this.basicDataModal.conceptData.allowPublicShare && !this.basicDataModal.conceptData.anonymousAccess) {
        this.basicDataModal.conceptData.lockedEdit = false;
      }
      if(this.type === 'edit'){
        this.handleAccept();
      }else{
        this.basicDataModal.conceptData.folderId = this.concept.folderId;
        this.basicDataModal.conceptData.isFront = true;
        this.apiService.add('Concepts/'+this.dialogConfig.data.configuration.evaluationId, this.basicDataModal.conceptData)
          .then((data:any)=>{
            this.basicDataModal.conceptData = data;
            this.handleAccept();
          })
      }
    }
  }

  restore(type:any, newValue:boolean){
    this.basicDataModal.conceptData[type] = newValue;
    switch(type){
      case 'allowPublicShare':
        delete this.basicDataModal.changedAllowPublicShare;
        this.basicDataModal.conceptData.poll = false;
        this.basicDataModal.conceptData.anonymousAccess = false;
        this.basicDataModal.conceptData.sequentialView = false;
        if(this.basicDataModal.conceptData.allowPublicShare === false){
          this.basicDataModal.conceptData.lockedEdit = false;
          this.basicDataModal.conceptData.restrictedDelete = false;
          this.basicDataModal.conceptData.communicationChannel = false;
        } else {
          this.basicDataModal.changedAllowPublicShare = true;
          this.basicDataModal.conceptData.lockedEdit = this.concept.lockedEdit;
          this.basicDataModal.conceptData.restrictedDelete = this.concept.restrictedDelete;
        }
        break;
      case 'groupsAsList':
        if(this.basicDataModal.conceptData.groupsAsList === true){
          this.basicDataModal.conceptData.sequentialView = false;
        }
        break;
      case 'poll':
        this.basicDataModal.conceptData.allowPublicShare = false;
        this.basicDataModal.conceptData.lockedEdit = false;
        if(this.basicDataModal.conceptData.poll === false){
          this.basicDataModal.conceptData.anonymousAccess = false;
          this.basicDataModal.conceptData.sequentialView = false;
        }
        break;
      case 'sequentialView':
        if(this.basicDataModal.conceptData.sequentialView){
          this.basicDataModal.conceptData.groupsAsList = false;
        }
        break;
      default:
        break;
    }
  }

  communicationChannel(){
    if(this.basicDataModal.conceptData.communicationChannel){
      this.basicDataModal.changedCommunicationChannel = false;
      this.basicDataModal.conceptData.communicationChannel = !this.basicDataModal.conceptData.communicationChannel
    }else{
      this.basicDataModal.changedCommunicationChannel = true;
      this.basicDataModal.conceptData.communicationChannel = true;
      this.basicDataModal.conceptData.lockedEdit = true;
      this.basicDataModal.conceptData.restrictedDelete = true;
    }
  }

  getEditorValue(event:any){
    this.basicDataModal.conceptData.description = event.newValue;
  }

  handleAccept() {
    if(!this.basicDataModal.conceptData.allowPublicShare && !this.basicDataModal.conceptData.anonymousAccess){
      this.basicDataModal.conceptData.lockedEdit = false;
    }
    if(this.basicDataModal.conceptData.stateLockedEdit && !this.basicDataModal.conceptData.lockedEdit){
      this.basicDataModal.conceptData.stateLockedEdit = false;
    }
    this.dialogRef.close({
      result: 'ok',
      concept: this.basicDataModal.conceptData,
      changedCommunicationChannel: this.basicDataModal.changedCommunicationChannel,
      changedAllowPublicShare: this.basicDataModal.changedAllowPublicShare
    })
  }

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  }
}
